import { Component, input } from '@angular/core';

import { Subject } from 'rxjs';

import {
  ByDayComponent,
  ByMonthComponent,
  CamBucketContainerComponent,
  CamBucketItemComponent,
  CamCalendarComponent,
  CamCalendarHeaderComponent,
  CamCalendarSchedulerHeaderComponent,
  CamCalendarSchedulerViewComponent,
  CamCalendarViewComponent,
  CamSchedulerComponent,
  provideCalendar,
} from '@camelot/calendar';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
  standalone: true,
  template: `<div>{{ this.event() ? 'event' : 'no event' }}</div>`,
})
export class E2eEventCardComponent {
  event = input<unknown>();
}

@Component({
    imports: [
        ByDayComponent,
        ByMonthComponent,
        CamBucketContainerComponent,
        CamBucketItemComponent,
        CamCalendarComponent,
        CamCalendarHeaderComponent,
        CamCalendarSchedulerHeaderComponent,
        CamCalendarSchedulerViewComponent,
        CamCalendarViewComponent,
        CamSchedulerComponent,
        TestIdDirective,
    ],
    providers: [provideCalendar()],
    template: `
    <cam-calendar
      camTestId="cam-calendar"
      planningId="e2e-calendar"
      [events]="this.empty"
      [timeRanges]="this.empty"
      [cardComponent]="this.card"
    />
    <cam-calendar-header camTestId="cam-calendar-header" planningId="e2e-calendar" />
    <cam-calendar-view camTestId="cam-calendar-view" planningId="e2e-calendar" />
    <cam-scheduler
      camTestId="cam-scheduler"
      planningId="e2e-scheduler"
      [events]="this.empty"
      [resources]="this.resources"
      [ressourceCard]="null"
      [cardComponent]="this.card"
    />
    <cam-calendar-scheduler-header camTestId="cam-calendar-scheduler-header" planningId="e2e-scheduler" />
    <cam-calendar-scheduler-view camTestId="cam-calendar-scheduler-view" planningId="e2e-scheduler" />
    <cam-calendar-by-day camTestId="cam-calendar-by-day" [eventTemplate]="eventTemplate" [refresh]="this.refresh" />
    <cam-calendar-by-month camTestId="cam-calendar-by-month" />
    <cam-calendar-bucket-container camTestId="cam-calendar-bucket-container">
      <cam-calendar-bucket-item camTestId="cam-calendar-bucket-item" [data]="this.bucketData">
        bucket item
      </cam-calendar-bucket-item>
    </cam-calendar-bucket-container>
    <ng-template #eventTemplate let-event="event">
      <div>day event</div>
    </ng-template>
  `
})
export class CalendarCase {
  public bucketData = { id: 'bucket-1' };
  public card = E2eEventCardComponent;
  public empty = [];
  public refresh = new Subject<void>();
  public resources: never[] = [];
}
